export namespace UserTypeConstant {
    export const Admin: string = "Admin";
    export const Employee: string = "Employee";
    export const Customer : string = "Customer";
    export const Affiliate: string = "Affiliate";
}



// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/security/user-type.constant.ts